import { DomainEvent } from '../../../../../core/domain/events/domain_event';
import { Goal } from '../../goal/goal';

export class GoalEvent extends DomainEvent<Goal> {}
export class GoalCreated extends GoalEvent {}
export class GoalUpdated extends GoalEvent {}
export class GoalChangeAchievement extends GoalEvent {}
